import { bookmarkReasons } from '@/mocks/home';

export default function WhyBookmark() {
  return (
    <section className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-100 border-y border-background-200/70">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="order-2 lg:order-1">
          <div className="flex items-center gap-3 mb-4">
            <span className="font-heading text-sm font-bold text-primary-600">02</span>
            <span className="w-8 h-px bg-primary-300" />
            <span className="font-label text-xs tracking-[0.28em] text-foreground-500 uppercase">
              Why Bookmark
            </span>
          </div>
          <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl lg:text-4xl leading-snug">
            为什么建议把这一页收藏起来
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600 max-w-xl">
            入口会变、地址会换，唯一稳定的做法是记住一个「中转页」。下面这几点，正是本页长期存在的意义。
          </p>

          <div className="mt-8 space-y-5">
            {bookmarkReasons.map((reason) => (
              <div key={reason.id} className="flex gap-4">
                <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-background-50 border border-background-200 text-xl text-primary-600">
                  <i className={reason.icon} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading font-bold text-base text-foreground-950">
                    {reason.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                    {reason.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-300/70 bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20editorial%20desk%20scene%20with%20a%20laptop%20showing%20a%20green%20streaming%20platform%2C%20warm%20cream%20and%20emerald%20color%20palette%2C%20soft%20natural%20light%2C%20minimal%20magazine%20still%20life%20photography%2C%20clean%20background%20with%20generous%20empty%20space&width=1200&height=900&seq=qpg-bookmark-cover&orientation=landscape"
              alt="收藏青苹果影院入口页面的场景"
              title="收藏青苹果影院官网入口最新地址"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}